import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Permanent redirect from the legacy ``/workspace/integrations`` URL
 * (June 10, 2026 — the hub was promoted to the fullscreen ``_modal``
 * group). Preserved as a route file so old bookmarks, in-flight
 * WebSocket payloads, and any third-party deep-link keep working.
 *
 * Real implementation lives at
 * ``apps/client/src/routes/_authed/_modal/integrations/route.tsx``.
 */
export const Route = createFileRoute("/_authed/workspace/integrations")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/integrations",
      search: search as Record<string, unknown>,
      replace: true,
    });
  },
});
